"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/support/env.ts
var env_exports = {};
__export(env_exports, {
  getLocalStorage: () => getLocalStorage,
  getSessionStorage: () => getSessionStorage,
  isClient: () => isClient,
  isServer: () => isServer,
  setLocalStorage: () => setLocalStorage,
  setSessionStorage: () => setSessionStorage
});
module.exports = __toCommonJS(env_exports);
var isClient = typeof window !== "undefined" && window.document && window.document.createElement;
var isServer = !isClient;
var setLocalStorage = (key, value) => {
  try {
    if ("localStorage" in window && window["localStorage"] !== null) {
      localStorage.setItem(key, value);
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
var getLocalStorage = (key) => {
  try {
    if ("localStorage" in window && window["localStorage"] !== null) {
      return localStorage.getItem(key);
    }
    return null;
  } catch (error) {
    return null;
  }
};
var setSessionStorage = (key, value) => {
  try {
    if ("sessionStorage" in window && window["sessionStorage"] !== null) {
      sessionStorage.setItem(key, value);
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};
var getSessionStorage = (key) => {
  try {
    if ("sessionStorage" in window && window["sessionStorage"] !== null) {
      return sessionStorage.getItem(key);
    }
    return null;
  } catch (error) {
    return null;
  }
};
